import { SubscriptionScopeKey } from "./helper/subscription/enum/SubscriptionScopeKey";
import { PlanType } from '../../enums/PlanType';

export const useDummyData = false;

// export const SubscriptionScopeDummy = {
//     // Modules
//     [SubscriptionScopeKey.sales]: true,
//     [SubscriptionScopeKey.purchases]: true,
//     [SubscriptionScopeKey.banking]: true,
//     [SubscriptionScopeKey.shoebox]: false,
//     [SubscriptionScopeKey.reports]: false,

// //     // Specific Modules
// //     [SubscriptionScopeKey.batch_sales]: false,
// //     [SubscriptionScopeKey.batch_purchases]: false,
// //     [SubscriptionScopeKey.batch_bank]: false,
// //     [SubscriptionScopeKey.bank_reconciliation]: true,
// //     [SubscriptionScopeKey.journal_entry]: true,
// //     [SubscriptionScopeKey.asset]: true,
// //     [SubscriptionScopeKey.instruction]: true,
// //     [SubscriptionScopeKey.tag]: true,
// //     [SubscriptionScopeKey.manage_custom_field]: false,

//     [SubscriptionScopeKey.inventory_tracking]: false,
//     [SubscriptionScopeKey.email_tracker]: false,
//     [SubscriptionScopeKey.e_invoicing]: false,
//     [SubscriptionScopeKey.invoice_reminder]: false,
//     [SubscriptionScopeKey.payment_gateway]: false,
//     [SubscriptionScopeKey.form_design]: false,
//     [SubscriptionScopeKey.sst]: false,

//     // Multi-based
//     [SubscriptionScopeKey.multi_location]: true,
//     [SubscriptionScopeKey.multi_uom]: true,
//     [SubscriptionScopeKey.multi_currency]: true,
//     [SubscriptionScopeKey.multi_user]: false,
//     [SubscriptionScopeKey.multi_number]: false,
//     [SubscriptionScopeKey.multi_price_level]: true,

// //     // Manage-based
// //     [SubscriptionScopeKey.manage_contact]: true,
// //     [SubscriptionScopeKey.manage_contact_group]: true,
// //     [SubscriptionScopeKey.manage_product]: true,
// //     [SubscriptionScopeKey.manage_product_bundle]: true,
// //     [SubscriptionScopeKey.manage_product_group]: true,
// //     [SubscriptionScopeKey.manage_product_price_level]: true,
// //     [SubscriptionScopeKey.manage_custom_field]: true,

// };

export const SubscriptionQuotaDummy = {
    plan_type: PlanType.PREMIUM,
    limit_period_type: "MONTHLY",
    transaction: {
        usage: 55,
        limit: false,
    },
    shoebox: {
        usage: 1,
        limit: 700,
    },
    email: {
        usage: 15,
        limit: 10000,
    },
    storage: {
        usage: 59165119,
        limit: 53687091200,
    },
    whatsapp: {
        usage: 12,
        limit: 200,
    },
    user: {
        usage: 1,
        limit: 2,
    },
};

// NEW FEATURES
export const SubscriptionScopeDummy = {
    // // Analytics
    // // [SubscriptionScopeKey.dashboard]: true,
    // [SubscriptionScopeKey.reports]: true,

    // // Sales
    // // [SubscriptionScopeKey.sales]: true,
    // [SubscriptionScopeKey.sales_batch]: true,
    // [SubscriptionScopeKey.payment_gateway]: false,

    // // Purchases
    // [SubscriptionScopeKey.purchases]: false,
    // [SubscriptionScopeKey.purchases_batch]: false,

    // // Banking
    // [SubscriptionScopeKey.bank_income_expense]: true,
    // [SubscriptionScopeKey.bank_income_expense_batch]: true,
    // [SubscriptionScopeKey.bank_transfer]: true,
    // [SubscriptionScopeKey.bank_reconciliation]: true,

    // // Contacts
    // [SubscriptionScopeKey.manage_contact]: true,
    // [SubscriptionScopeKey.manage_contact_group]: false,
    // [SubscriptionScopeKey.e_statement]: false,

    // // Products
    // // [SubscriptionScopeKey.manage_product]: true,
    // [SubscriptionScopeKey.manage_product_bundle]: false,
    // [SubscriptionScopeKey.manage_product_group]: false,
    // [SubscriptionScopeKey.manage_price_level]: false, // will not work fully in transactions with dummy data
    // [SubscriptionScopeKey.multi_uom]: true, // will not work fully in transactions with dummy data
    // [SubscriptionScopeKey.inventory_tracking]: true,
    // [SubscriptionScopeKey.multi_location]: false,

    // // Accounting & Tax
    // [SubscriptionScopeKey.journal_entry]: true,
    // [SubscriptionScopeKey.contra]: true,
    // [SubscriptionScopeKey.manage_asset]: true,
    // // [SubscriptionScopeKey.manage_chart_of_account]: true,
    // [SubscriptionScopeKey.tax_sst_gst]: false,

    // // Automations
    // [SubscriptionScopeKey.shoebox]: true,
    // [SubscriptionScopeKey.e_invoicing]: false,
    // [SubscriptionScopeKey.invoice_reminder]: true,
    // [SubscriptionScopeKey.e_statement_automated]: true,
    // [SubscriptionScopeKey.instruction_contact]: false,
    // [SubscriptionScopeKey.instruction_contact_group]: true,

    // // Other features
    // [SubscriptionScopeKey.multi_number_format]: false,
    // [SubscriptionScopeKey.multi_form_design]: false,
    // [SubscriptionScopeKey.manage_custom_field]: false,
    // [SubscriptionScopeKey.multi_currency]: false,
    // // [SubscriptionScopeKey.multi_user]: true,
    // [SubscriptionScopeKey.tag]: false,
    // [SubscriptionScopeKey.permission]: SubscriptionPermissionType.BASIC,
    // [SubscriptionScopeKey.bukku_store]: false,

    // // Integrations
    // [SubscriptionScopeKey.payroll]: true,

    // SOON TO BE DEPRECATED
    // [SubscriptionScopeKey.banking]: false,
    // [SubscriptionScopeKey.batch_bank]: false,
    // [SubscriptionScopeKey.instruction]: true,
    // [SubscriptionScopeKey.email_tracker]: false,
    // [SubscriptionScopeKey.tax_sst]: false,

    // Analytics
    [SubscriptionScopeKey.DASHBOARD]: false,
    [SubscriptionScopeKey.REPORT]: false,

    // Sales
    [SubscriptionScopeKey.SALE]: true,
    [SubscriptionScopeKey['SALE.PAYMENT_GATEWAY']]: false,
    [SubscriptionScopeKey['SALE.LATE_INTEREST']]: false,
    [SubscriptionScopeKey['SALE.INVOICE_REMINDER']]: false,

    // Purchases
    [SubscriptionScopeKey.PURCHASE]: false,

    // Banking
    [SubscriptionScopeKey['BANK.TRANSACTION']]: false,
    [SubscriptionScopeKey['BANK.RECONCILIATION.MANUAL']]: false,
    [SubscriptionScopeKey['BANK.RECONCILIATION.AUTO']]: true,

    // All Transactions
    [SubscriptionScopeKey['TRANSACTION.BULK_CREATE']]: false,
    [SubscriptionScopeKey['TRANSACTION.SHOEBOX']]: true,
    [SubscriptionScopeKey['TRANSACTION.QUICKSHARE']]: true, // previously 'TRANSACTION.E_INVOICE'
    [SubscriptionScopeKey['TRANSACTION.INSTRUCTION']]: true,
    [SubscriptionScopeKey['TRANSACTION.INSTRUCTION.CONTACT_GROUP']]: false,

    // Contacts
    [SubscriptionScopeKey.CONTACT]: true,
    [SubscriptionScopeKey['CONTACT.BULK_IMPORT']]: false,
    [SubscriptionScopeKey['CONTACT.GROUP']]: false,
    [SubscriptionScopeKey['CONTACT.STATEMENT']]: false,
    [SubscriptionScopeKey['CONTACT.STATEMENT.E_STATEMENT']]: true,
    [SubscriptionScopeKey['CONTACT.STATEMENT.E_STATEMENT.AUTO']]: false,

    // Products & Services
    [SubscriptionScopeKey.PRODUCT]: false,
    [SubscriptionScopeKey['PRODUCT.BULK_IMPORT']]: false,
    [SubscriptionScopeKey['PRODUCT.BUNDLE']]: false,
    [SubscriptionScopeKey['PRODUCT.GROUP']]: true,
    [SubscriptionScopeKey['PRODUCT.MULTI_UOM']]: false,
    [SubscriptionScopeKey['PRODUCT.CUSTOM_PRICE']]: false,

    // Inventory Tracking
    [SubscriptionScopeKey.INVENTORY]: false,
    [SubscriptionScopeKey['INVENTORY.MULTI_LOCATION']]: false,
    [SubscriptionScopeKey['INVENTORY.STOCK_ADJUSTMENT']]: false,
    [SubscriptionScopeKey['INVENTORY.STOCK_TRANSFER']]: false,

    // Accounting & Tax
    [SubscriptionScopeKey['ACCOUNTING.JOURNAL_ENTRY']]: false,
    [SubscriptionScopeKey['ACCOUNTING.CONTRA']]: false,
    [SubscriptionScopeKey['ACCOUNTING.FIXED_ASSET']]: false,
    [SubscriptionScopeKey['TAX.SST']]: false,

    // Other Features
    [SubscriptionScopeKey.MULTI_NUMBER_FORMAT]: false,
    [SubscriptionScopeKey.MULTI_FORM_DESIGN]: true,
    [SubscriptionScopeKey.MULTI_CURRENCY]: false,
    [SubscriptionScopeKey.CUSTOM_FIELD]: false,
    [SubscriptionScopeKey.PRICE_LEVEL]: false,
    [SubscriptionScopeKey.TAG]: false,
    [SubscriptionScopeKey.USER_PERMISSION]: false,
    [SubscriptionScopeKey['USER_PERMISSION.ADVANCED']]: false,
    [SubscriptionScopeKey.STORE]: true,
    [SubscriptionScopeKey.FLOW]: true,

    // Integrations
    [SubscriptionScopeKey['INTEGRATION.PAYROLL']]: false,
    [SubscriptionScopeKey['INTEGRATION.OPEN_API']]: false,

    // Peace of Mind
    [SubscriptionScopeKey.LIVE_CHAT]: false,
};
